var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('div',[_c('product-categories-select',{attrs:{"clearable":true},model:{value:(_vm.filters.category),callback:function ($$v) {_vm.$set(_vm.filters, "category", $$v)},expression:"filters.category"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }